import { Box, Tabs, Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { hasPermission } from 'store'


export const tabConfig = [
    {
        index: 0,
        label: 'Evaluation',
        path: "evaluation",
        permission: 'evaluation.admin'
    },
    {
        index: 1,
        label: "Indicator List",
        path: "indicator-list",
        permission: 'evaluation.admin'
    }
]

export default function AdminEvaluationTabs() {
    const basePath = '/admin-evaluation'
    const theme = useSelector(state => state.session.appearance)
    const { '*': tabName } = useParams()

    const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission));
    const { t } = useTranslation()

    const getTabIndex = path => {
        const [tabName] = path.split("/");
        const found = permittedTabs.find(tab => tab.path === tabName);
        return found ? found.index : permittedTabs[0]?.index ?? 0;
    };
    const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

    useEffect(() => {
        setTabIndex(getTabIndex(tabName));
    }, [tabName, permittedTabs.length]);

    useEffect(() => {
        setTabIndex(getTabIndex(tabName))
    }, [tabName])

    return (
        <Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
                <Tabs value={tabIndex}>
                    {permittedTabs.map(tab => (
                        <Tab
                            key={tab.path}
                            sx={{ color: tabIndex === tab.index && "primary !important" }}
                            className={tabIndex === tab.index
                                ? `tab-item-selected`
                                : `tab-item-${theme}`
                            }
                            label={t(tab.label)}
                            value={tab.index}
                            component={Link}
                            to={`${basePath}/${tab.path}`}
                            disabled={tab.disabled}
                        />
                    ))}
                </Tabs>
            </Box>
        </Box>
    )
}

